import { ActionIcon, Tooltip } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

interface DeleteButtonProps {
  disabled?: boolean;
  label?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function DeleteButton({
  disabled,
  label = "Löschen",
  onClick
}: DeleteButtonProps) {
  return (
    <Tooltip label={label}>
      <ActionIcon
        aria-label={label}
        color="error"
        disabled={disabled}
        size="xs"
        variant="transparent"
        onClick={onClick}
      >
        <IconTrash className="delete-icon" data-testid="icon-button-delete" />
      </ActionIcon>
    </Tooltip>
  );
}

export { DeleteButton, DeleteButtonProps };
